import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
// Custom components
import LinkArrow from '../../../components/Arrow';
import ArrowSrc from '../../../images/arrowRightDark.svg';
import { colors } from '../../../styles/constants';
// Constants
import { ALT_ARTICLE_ICON_ARROW, FAQ_URL } from '../constants';
import FaqText from './FaqText';

const Link = styled(NavLink)`
  ${tw`flex flex-row my-abs1 
    cursor-pointer pb-abs1 no-underline`}
  border-bottom: 1px solid ${colors.grey200};
`;

const LinkText = styled(FaqText)`
  ${tw`font-medium pl-0 mb-0 
    text-text mr-abs2`};
`;

const ArticleLink = ({ articleName, articleTitle }) => (
  <Link id={articleName} to={`${FAQ_URL}/${articleName}`}>
    <LinkText>{articleTitle}</LinkText>
    <LinkArrow alt={ALT_ARTICLE_ICON_ARROW} parentHover={Link} src={ArrowSrc} />
  </Link>
);

ArticleLink.propTypes = {
  articleName: PropTypes.string,
  articleTitle: PropTypes.string,
};

export default ArticleLink;
